import React from "react";

import type { CategoryKey } from "~/sdks/LocalContent/types";

import { CategoryTitle } from "~/sdks/LocalContent/components/CategoryTitle";
import { Slider as SliderComponent } from "~/sdks/LocalContent/components/Slider";
import { CloseButton } from "./CloseButton";

import { useRootElement } from "../context";

import * as styles from "./styles";

export function Slider({
  categoryKey,
  children,
}: {
  categoryKey: CategoryKey | null;
  children?: React.ReactNode;
}) {
  const { activeCategory } = useRootElement();

  return (
    <SliderComponent isOpen={!!activeCategory}>
      <div className={styles.header}>
        <CloseButton />
        {categoryKey && <CategoryTitle categoryKey={categoryKey} />}
      </div>

      <div className={styles.content}>{children}</div>
    </SliderComponent>
  );
}
